import type { Methodology } from '@/composables/useApi'

/**
 * Generates a unique key for a methodology object
 * Format: ${tenantId}:${accountId}:${methodologyKey}
 */
export const generateMethodologyKey = (methodology: Methodology): string => {
  return `${methodology.tenantId}:${methodology.accountId}:${methodology.methodologyId}`
}